exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".overlay {\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  border: 1px solid #cccccc;\n  box-sizing: border-box;\n  -moz-border-radius: 2px;\n  -webkit-border-radius: 2px;\n  border-radius: 2px;\n  -webkit-box-shadow: 0 1px 3px rgba(116, 116, 116, 0.25);\n  -moz-box-shadow: 0 1px 3px rgba(116, 116, 116, 0.25);\n  box-shadow: 0 1px 3px rgba(116, 116, 116, 0.25); }\n\n.overlay-content {\n  padding: 0.5em 1em;\n  background-color: #ffffff; }\n\n.overlay-close {\n  display: flex;\n  justify-content: flex-end;\n  flex: 1; }\n\n.overlay-title {\n  justify-content: flex-start;\n  flex: 0 0 24px;\n  font-size: 18px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/common/overlay/overlay.scss
// module id = AcDD
// module chunks = 0